<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2019 (original work) Open Assessment Technologies SA ;
    import { __ } from '@oat-sa-private/ui-core';
    import { createEventDispatcher } from 'svelte';
    import CheckCell from './CheckCell.svelte';
    import { Checkbox } from '@oat-sa-private/ui-elements';

    export let title;
    export let subTitle;
    export let cellComponent;
    export let sortable = false;
    export let allSelected = false;
    export let someSelected = false;
    export let sortOrder;

    let sortLabel;

    $: showTitleBlock = title || subTitle;

    $: if (sortOrder === 'asc') {
        sortLabel = __('Click to sort descending');
    } else if (sortOrder === 'desc') {
        sortLabel = __('Click to sort ascending');
    } else {
        sortLabel = __('Click to sort');
    }

    const dispatch = createEventDispatcher();

    function onSelectChange(checked) {
        dispatch('selectChange', {
            checked
        });
    }
</script>

<style>
    .cell-wrapper {
      display: flex;
      align-items: flex-start;
    }

    .cell-wrapper > :global(*) {
        margin-left: 0;
        margin-right: 0;
    }

    .cell-wrapper > :global(* + *) {
        margin-left: var(--space-1x5);
    }

    .sort-indicator {
        display: flex;
        flex-direction: column;
        margin-top: 0.625rem;
    }

    .sort-indicator-arrow {
        height: 0.75rem;
        width: 0.875rem;
        color: var(--color-gs-disabled-invert);
    }

    .descending {
        transform: rotate(180deg);
        margin-top: var(--space-quarter);
    }

    .active {
        color: var(--color-brand);
    }

    .inactive {
        color: var(--color-gs-light-secondary);
    }

    .subtitle {
        font-size: var(--fontsize-heading-s);
        font-weight: 300;
        margin-top: var(--space-half);
    }
</style>

<div class="cell-wrapper">
    {#if sortable}
    <div
        class="sort-indicator"
    >
        <svg
            class="sort-indicator-arrow ascending"
            class:active={sortOrder === 'asc'}
            class:inactive={sortOrder === 'desc'}
            viewBox="0 0 7 6"
            aria-hidden="true"
        >
            <path d="M6.93,5.24l-3-5.01c-0.18-0.3-0.68-0.3-0.86,0l-3,5.01c-0.09,0.15-0.1,0.35-0.01,0.5C0.15,5.9,0.32,6,0.5,6h6
              c0.18,0,0.35-0.1,0.44-0.25C7.02,5.59,7.02,5.4,6.93,5.24z" fill="currentColor" />
        </svg>
        <svg
            class="sort-indicator-arrow descending"
            class:active={sortOrder === 'desc'}
            class:inactive={sortOrder === 'asc'}
            viewBox="0 0 7 6"
            aria-hidden="true"
        >
            <path d="M6.93,5.24l-3-5.01c-0.18-0.3-0.68-0.3-0.86,0l-3,5.01c-0.09,0.15-0.1,0.35-0.01,0.5C0.15,5.9,0.32,6,0.5,6h6
              c0.18,0,0.35-0.1,0.44-0.25C7.02,5.59,7.02,5.4,6.93,5.24z" fill="currentColor" />
        </svg>
      </div>
    {/if}
    {#if showTitleBlock}
        <div>
            <div>{title}</div>
            {#if subTitle}
                <div class="subtitle">{subTitle}</div>
            {/if}
            {#if sortable}
                <span class="visually-hidden">({sortLabel})</span>
            {/if}
        </div>
    {/if}
    {#if cellComponent === CheckCell}
        <Checkbox
            checked={allSelected}
            indeterminate={someSelected}
            ariaLabel={__('Select All')}
            on:change={event => onSelectChange(event.detail)}
        />
    {/if}
</div>